import { _ } from "../../polyglot/polyglot.js";
import { groupItems } from "../../elements/select/migration.js";
import { select, theme } from "../../elements/index.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 *
 * `keyFigureCategoryPickerWidget` is used to encapsulate a dropdown displayed
 * only when a predicate is satisfied.
 *
 * It is designed to allow the user to choose among multiple categories,
 * but only if there are multiple categories.
 *
 * @param {{}} spec - Parameter object
 * @param {string} [spec.id]                 - dropdown id.
 * @param {*[]} spec.categories                 - list of categories to display
 * @param {function} spec.categoryRenderer      - optional function used to compute a renderable object out of a category.
 *                                              Default implementation returns the category.
 * @param {function} spec.isVisiblePredicate    - predicate to determinate if the dropdown should
 *                                              be visible or not
 * @param {{}} my - protected fields holder
 * @return {*}
 */
function keyFigureCategoryPickerWidget(spec, my) {
	spec ||= {};
	my ||= {};
	const that = widget(spec, my);

	my.categories = spec.categories || [];
	const isVisiblePredicate = spec.isVisiblePredicate;
	const pickerId = spec.pickerId || "";

	my.onChangeCallback = () => {};

	that.setCategories = function (categories) {
		my.categories = categories;
		that.update();
	};

	function makeSelectItems() {
		const allItem = { label: _("All"), value: "all", selected: true };

		const categories = my.categories.map((category) => ({
			label: category.getName(),
			value: category,
			group: category.getGroup(),
		}));

		return [
			allItem,
			...groupItems({
				items: categories,
				getGroup: (item) => item.getGroup(),
				labelForGroup: (group) => group.toString(),
			}),
		];
	}

	that.onChange = function (callback) {
		my.onChangeCallback = callback;
	};

	that.renderContentOn = function (html) {
		if (!my.categories || !isVisiblePredicate(my.categories)) {
			return;
		}

		html.render(
			theme(
				{ name: "dark-select" },
				select({
					ref: (ref) => {
						ref.setAttribute("id", pickerId);
						ref.setAttribute("name", "key-figure-categories");
					},
					items: makeSelectItems(),
					onChange: (...args) => my.onChangeCallback(...args),
				}),
			),
		);
	};

	return that;
}

export default keyFigureCategoryPickerWidget;
